import {
  getSurfaceProgress,
  progressColor,
  type SurfaceProgressScores,
} from './surface-build-progress';

const COL_WIDTH = 26;

const COLS: { key: keyof SurfaceProgressScores; label: string; fullName: string }[] = [
  { key: 'dataModel', label: 'DM', fullName: 'Data model' },
  { key: 'backend', label: 'BE', fullName: 'Backend' },
  { key: 'ui', label: 'UI', fullName: 'UI surface' },
  { key: 'total', label: 'Σ', fullName: 'Total' },
];

export function BuildDocProgressHeader() {
  return (
    <div
      className="flex items-center tabular docs-progress-header"
      style={{
        padding: '0 8px 8px',
        fontSize: 9,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        fontWeight: 600,
        color: 'var(--ink-tertiary)',
        gap: 0,
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }} />
      {COLS.map((col) => (
        <span
          key={col.key}
          className="tt-below"
          aria-label={col.fullName}
          tabIndex={0}
          style={{
            width: COL_WIDTH,
            textAlign: 'right',
            flexShrink: 0,
          }}
        >
          {col.label}
        </span>
      ))}
    </div>
  );
}

export function BuildDocProgressCells({ docKey }: { docKey: string }) {
  const progress = getSurfaceProgress(docKey);
  if (!progress) return null;

  return (
    <span className="flex tabular" style={{ flexShrink: 0, gap: 0 }} aria-hidden>
      {COLS.map((col) => {
        const value = progress[col.key];
        const emphasize = col.key === 'total';
        return (
          <span
            key={col.key}
            style={{
              width: COL_WIDTH,
              textAlign: 'right',
              fontSize: emphasize ? 11 : 10,
              fontWeight: emphasize ? 600 : 500,
              color: progressColor(value),
            }}
          >
            {value}
          </span>
        );
      })}
    </span>
  );
}
